export default __webpack_public_path__ + "66251f6b9359945d9a65545641222667.jpg";